// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"reviews_infoWrapper__Gz_80","info":"reviews_info__tuce9","button":"reviews_button___jir0"};